import pako from 'pako';
import { getAuthToken } from "../utils/AuthUtils";

const WEBSOCKET_URL = process.env.REACT_APP_WEBSOCKET_API;

export const prepareWebSocketConnection = async (request, handleSuccess, handleError ) => {
            const authToken = await getAuthToken();

            const url = `${WEBSOCKET_URL}/?token=${authToken}`;
            const socket = new WebSocket(url);

            socket.addEventListener("open", (event) => {
                const eventStr = compressDownloadRequestData("download", request)
                const textEncoder = new TextEncoder()
                if (textEncoder.encode(eventStr).length > 128000) {
                    handleError("Automation request is too large. Plese select fewer rows or tickers.");
                    socket.close();
                } else {
                    socket.send(eventStr);
                }
            });

            socket.addEventListener("error", (event) => {
                handleError("An error occured downloading data");
                console.log("WebSocket error: " + event);
                socket.close();
            })

            socket.addEventListener("close", (event) => {
                console.log("WebSocket connection closed");
            })

            socket.addEventListener("message", (event) => {
                const data = JSON.parse(event?.data);
                if (data?.url) {
                    handleSuccess(data.url);
                    socket.close();
                } else if (data?.error) {
                    handleError(data.error);
                    socket.close();
                }
            });
}


const compressDownloadRequestData = (websocketAction, request) => {
    try {
      const requestStr = JSON.stringify(request);
      const compressedRequest = pako.deflate(requestStr, { to: 'string' });
      const compressedSting = String.fromCharCode.apply(null, compressedRequest)
      const base64Encoded = btoa(compressedSting);
      return JSON.stringify({ action: websocketAction, data: base64Encoded });
    } catch (e) {
      console.log(e)
      throw new Error();
    }
  }